export const UPCOMING = "UPCOMING";
export const PAST = "PAST";
export const PAST_APPOINTMENTS = "past-appointments";
export const UPCOMING_APPOINTMENTS = "upcoming-appointments";
export const TELEHEALTH_ATTENDANCE_TYPE = "TELEHEALTH";